import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setAuthStatus } from "./authSlice";
import { domain } from "./authSlice";

export const domain_trap = `https://ml1.bird-trap-db.intelligent.by/`;

export const fetchCollection = createAsyncThunk(
  'collection/fetchCollection',
  async function (url, { rejectWithValue, dispatch }) {
     
    try {
      var response;
      if (localStorage.getItem('google') === 'true'){
        response = await fetch(`${url}`, {})
      } else {
        response = await fetch(`${url}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
      }
      if (!response.ok) {
        if (response.status === 401) {
          
          dispatch(setAuthStatus(false));
        }
        const errorMessage = await response.json();
        throw new Error(errorMessage.detail);
      }
      const data = await response.json()
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)
export const collectionUpdate = createAsyncThunk(
  'collection/update',
  async ({ isCheck, key, deleted, validated}, { rejectWithValue, dispatch, getState }) => {    
    const { currentPage } = getState().collection;

    try {
      const body = isCheck.map((id) => ({ id, [key]: deleted }))
      const response = await fetch(domain + `api/audio_list_views/?deleted=${!deleted}&validated=${validated}&page=${currentPage}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(body),
        redirect: 'follow'
      })
      if (!response.ok) {
        if (response.status === 401) {
          
          dispatch(setAuthStatus(false));
        }
        throw new Error('Some error update request')
      }
      const data = await response.json()
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
);

export const collectionAddNew = createAsyncThunk(
  'collection/collectionAddNew',
  async (values, { rejectWithValue, dispatch }) => {
    const formData = new FormData();
    var email = localStorage.getItem('email');
    var url = domain + `api/recognize-audio/`;

    formData.append('language', 'all');
    formData.append('email', email);
    
    if (values.lat!==null && values.lat!==''){
      formData.append('audio_file', values.audiorecord_local, values.name)
      formData.append('latitude', values.lat)
      formData.append('longitude', values.lng)
    }
    else {
      url = domain + `api/recognize/`;
      formData.append('audio_to_recognize', values.audiorecord_local, values.name)
      if (values.recorded_at !== '') {
        formData.append('date_of_collection', values.recorded_at)
      }
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        redirect: 'follow'
      })
      if (!response.ok) {
        if (response.status === 401) {          
          dispatch(setAuthStatus(false));
        }
        throw new Error('Some error add new request', response.statusText)
      }
      const data = await response.json()
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
);


export const collectionDeleteItem = createAsyncThunk(
  'collection/collectionDeleteItem',
  async (id, {dispatch, rejectWithValue }) => {
    try {
      const response = await fetch(domain + `api/audio_list_views/${id}/`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
      })
      if (!response.ok) {
        if (response.status === 401) {          
          dispatch(setAuthStatus(false));
        }
        throw new Error('Some error delete request')
      }
      dispatch(fetchCollection(domain + 'api/audio_list_views/?deleted=true'))
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const getSortedTraps = createAsyncThunk(
  'soundTraps/getSortedTraps',
  async function ({startDate, finishDate, startTime, finishTime}, { rejectWithValue, dispatch }) {
     
    try {
      const response = await fetch(domain_trap + `api/birds/paginated/sorted-filter?date_start=${startDate}&date_finish=${finishDate}&time_start=${startTime}:00&time_finish=${finishTime}:00&page_size=10`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      if (!response.ok) {
        if (response.status === 401) {
          
          dispatch(setAuthStatus(false));
        }
        const errorMessage = await response.json();
        throw new Error(errorMessage.detail);
      }
      const data = await response.json()
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)


const collectionSlice = createSlice({
  name: 'collection',
  initialState: {
    collection: [],
    status: null,
    error: null,    
    count: null,
    prev: null,
    next: null,
    statusAdd: null,
    errorAdd: null,
    currentPage: null
  },
  reducers: {
    resetAddState: (state) => {
      state.statusAdd = null
      state.errorAdd = null
    },
    resetError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollection.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCollection.fulfilled, (state, action) => {
        Object.assign(state, collectionSlice.initialState)
        state.status = 'succeeded'        
        state.collection = action.payload.results ?? action.payload.birds
        state.prev = action.payload.previous;
        state.next = action.payload.next
        state.count = action.payload.count
        state.currentPage = action.payload.current ?? action.payload.current_page
      })
      .addCase(fetchCollection.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(getSortedTraps.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getSortedTraps.fulfilled, (state, action) => {
        Object.assign(state, collectionSlice.initialState)
        state.status = 'succeeded'        
        state.collection = action.payload.birds
        state.prev = action.payload.previous;
        state.next = action.payload.next
        state.count = action.payload.count
        state.currentPage = action.payload.current_page
      })
      .addCase(getSortedTraps.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(collectionUpdate.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(collectionUpdate.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.collection = action.payload.results;
        state.prev = action.payload.previous;
        state.next = action.payload.next
        state.count = action.payload.count
        state.currentPage = action.payload.current
      })
      .addCase(collectionUpdate.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(collectionAddNew.pending, (state) => {
        state.statusAdd = 'loading';
        state.isAdd = false
        state.error = null
      })
      .addCase(collectionAddNew.fulfilled, (state, action) => {
        state.statusAdd = 'succeeded';
        state.isAdd = true
      })
      .addCase(collectionAddNew.rejected, (state, action) => {
        state.statusAdd = 'failed';
        state.isAdd = false
        state.errorAdded = action.payload;
      })
      .addCase(collectionDeleteItem.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(collectionDeleteItem.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(collectionDeleteItem.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
  },
})


export const { resetAddState, resetError } = collectionSlice.actions
export default collectionSlice.reducer